"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../../../login/login-connector"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _Division = _interopRequireDefault(require("./Division"));
var _addDivision = _interopRequireDefault(require("./add-division"));
var _divisionsHelp = _interopRequireDefault(require("./divisions-help"));
var _deleteButton = _interopRequireDefault(require("../../../../core/delete-button"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
const SetUpDivisions = (0, _loginConnector.default)(class extends _react.Component {
  render() {
    const comp = this.props.competition;
    const user = this.props.user;
    if (!comp.isAdministratedByUser) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_divisionsHelp.default, {
      competitionName: comp.competitionName
    })), !comp.userCanModifyCompetitionStructure ? null : /*#__PURE__*/_react.default.createElement(_addDivision.default, {
      competitionID: comp.id,
      competitionYearID: comp.yearID
    }), /*#__PURE__*/_react.default.createElement(_row.default, null, comp.competitionDivisions.map((division, i) => /*#__PURE__*/_react.default.createElement("div", {
      key: division.id,
      className: i % 2 ? 'clearfix' : ''
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-header"
    }, !division.userCanDeleteCompetitionDivision ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      onClick: this.props.onDelete.bind(this.props, division.id)
    })), /*#__PURE__*/_react.default.createElement("h2", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      type: "text",
      name: "raceName",
      value: division.description,
      maxLength: 20,
      onChange: this.props.onUpdate.bind(this, division.id, 'description')
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_Division.default, {
      competitionDivision: division,
      competitionID: comp.id,
      yearID: comp.yearID,
      competitionDays: comp.competitionDays,
      hasRaces: comp.hasRaces,
      user: user
    }))))))));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref = {
  competitionName: true,
  id: true,
  yearID: true,
  isAdministratedByUser: true,
  userCanModifyCompetitionStructure: true,
  hasRaces: true,
  competitionDays: _mergeBqlQueries({
    id: true
  }, _Division.default.partials.CompetitionDays),
  competitionDivisions: _mergeBqlQueries({
    id: true,
    description: true,
    userCanDeleteCompetitionDivision: true
  }, _Division.default.partials.Divisions)
};
var _default = exports.default = (0, _reactBicycle.connect)(SetUpDivisions, props => ({
  userIsSystemAdmin: true,
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref
}), (client, props) => ({
  onDelete(id) {
    return client.update('CompetitionDivision.delete', {
      id
    });
  },
  onUpdate(id, field, value) {
    return client.update('CompetitionDivision.set', {
      id,
      field,
      value
    });
  }
}));